import { useTranslation } from "react-i18next"

const DaysOfWeekData = () => {
    const { t } = useTranslation()
    return [
        { value: "monday", label: t('common.monday')},
        { value: "tuesday", label:  t('common.tuesday') },
        { value: "wednesday", label:  t('common.wednesday') },
        { value: "thursday", label:  t('common.thursday')},
        { value: "friday", label:  t('common.friday') },
        { value: "saturday", label:  t('common.saturday') },
        { value: "sunday", label:  t('common.sunday') }
    ]
}

export default DaysOfWeekData 